import { ADD_COMPONENT, CHANGE_PROP, CHANGE_VALUE_JSON } from "./componentActionTypes";

export function onChangeComponentProp(components) {
    return (dispatch) => {
        dispatch({
            type: CHANGE_PROP,
            payload: components.components
        })
    }
}


export function addComponent(component) {
    console.log(component);
    return (dispatch) => {
        dispatch({
            type: ADD_COMPONENT,
            payload: component
        })
    }
}


export function changeValueJSON(json) {
    console.log(json);
    return (dispatch) => {
        dispatch({
            type: CHANGE_VALUE_JSON,
            payload: json
        })
    }
}
